import {
  AfterViewInit,
  Directive,
  ElementRef,
  Input,
  OnInit,
} from '@angular/core';
import { NgxTippyService } from 'ngx-tippy-wrapper';
import { Observable } from 'rxjs';
import { Hint } from '../../core/models/hint.model';
import { Store } from '@ngxs/store';
import { map } from 'rxjs/operators';

@Directive({
  selector: '[brnHint]',
})
export class HintDirective implements OnInit, AfterViewInit {
  @Input() tippyName!: string;
  @Input() brnHintCategory?: string;
  @Input() brnHintName?: string;
  @Input() brnHintHideEmpty?: boolean;
  hint$?: Observable<Hint>;

  constructor(
    private elementRef: ElementRef,
    private store: Store,
    private tippyService: NgxTippyService
  ) {}

  ngOnInit(): void {
    if (this.brnHintHideEmpty) {
      this.elementRef.nativeElement.style.display = 'none';
    }
    this.tippyService.disable(this.tippyName);
  }

  ngAfterViewInit() {
    if (this.brnHintName || this.tippyName) {
      this.hint$ = this.store
        .selectOnce((state) => state.hint.hints)
        .pipe(
          map((hints) =>
            hints.find((hint: any) => {
              const name = this.brnHintName ? this.brnHintName : this.tippyName;
              if (this.brnHintCategory) {
                return (
                  hint.category &&
                  hint.category.name.toLowerCase() ===
                    this.brnHintCategory.toLowerCase() &&
                  hint.name.toLowerCase() === name.toLowerCase()
                );
              } else {
                return (
                  !hint.category &&
                  hint.name.toLowerCase() === name.toLowerCase()
                );
              }
            })
          )
        );
      this.hint$.subscribe((hint) => {
        let link, content;
        if (hint) {
          if (hint.link) {
            link = /https?:\/\//g.test(hint.link)
              ? hint.link
              : 'http://' + hint.link;
          }
          content =
            hint.preview +
            (link
              ? `<a href=${link} target="_blank"><span>Learn more</span><span class="material-icons"> navigate_next </span></a>`
              : '');
        }
        if (content) {
          this.tippyService.setContent(this.tippyName, content);
          this.tippyService.enable(this.tippyName);
          if (this.brnHintHideEmpty) {
            this.elementRef.nativeElement.style.display = '';
          }
        }
      });
    }
  }
}
